"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
//# sourceMappingURL=types.js.map